/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import '../../styles/day-picker-style.css';
import '../../styles/dayPickerRailReset.css';
import { MAX_NUMBER_OF_DAYS } from '../../utils/RailsSEOConstants';

const today = new Date();
const lastAllowedDate = new Date();

lastAllowedDate.setDate(lastAllowedDate.getDate() + MAX_NUMBER_OF_DAYS);
const disabledDays = {
  before: today,
  after: lastAllowedDate
};

function MobileCalendar({ onDateSelected, hideCalendar }) {
  const [selectedDay, setSelectedDay] = useState(undefined);

  function handleDayClick(day, modifiers = {}) {
    if (modifiers.disabled) {
      return;
    }
    setSelectedDay(modifiers.selected ? selectedDay : day);
  }

  return (
    <div className={'mobileDatePicker'}>
      <div className={'dayPickerHotelWrap'}>
        <div className="closeIcon" onClick={hideCalendar}></div>
        <DayPicker
          numberOfMonths={5}
          canChangeMonth={false}
          selectedDays={selectedDay}
          onDayClick={handleDayClick}
          fromMonth={new Date()}
          toMonth={lastAllowedDate}
          initialMonth={selectedDay}
          disabledDays={[disabledDays]}
        />
        {selectedDay && (
          <span className={'done'} onClick={() => onDateSelected(selectedDay)}>
            DONE
          </span>
        )}
      </div>
    </div>
  );
}

MobileCalendar.propTypes = {
  onDateSelected: PropTypes.func.isRequired,
  hideCalendar: PropTypes.func.isRequired
};

export default MobileCalendar;
